import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';
import { renderRoutes } from 'react-router-config';
import { ThemeProvider } from '@material-ui/styles';
import { themeBlue, themeGreen } from './theme';
import { SelectorProvider, ThemeCtx } from './context';
import { FormControlLabel, Switch, makeStyles } from '@material-ui/core'
import { useEffect } from 'react';



const useStyles = makeStyles(theme => ({
    themeSwitchWrapper: {
        position: 'fixed',
        top: '8px',
        right: '0',
        zIndex: '9999',
        color: '#fff',
        float: 'right'        
    }
}))

export default function Main() {
    const [mainTheme, setMainTheme] = React.useState(themeGreen);
    const [themeName, setThemeName] = React.useState('default');
    const [showThemeSelector, setShowThemeSelector] = React.useState(false);
    const tctx = React.useContext(ThemeCtx);
    const classes = useStyles(themeName === 'default' ? themeGreen : themeGreen);

    const handleChange = (event) => {
        setMainTheme(event.target.checked ? themeGreen : themeBlue);
        setThemeName(event.target.checked ? 'green' : 'default')        
    };        

    useEffect(() => {
        if (themeName) {
            tctx.theme = themeName;
        }
    }, [themeName]);
    
    
    return (     
        <div>            
            <BrowserRouter basename='/precios/'>                
                <ThemeProvider theme={mainTheme}>                    
                    <ThemeCtx.Provider value={{ theme: themeName }}>
                        <SelectorProvider value={{ rubro: 0, marca: 0, modelo: 0, modelosOptions: [] }}> 
                            { showThemeSelector 
                                ? <FormControlLabel
                                    className={classes.themeSwitchWrapper}
                                    control={
                                        <Switch
                                            checked={themeName === 'green'}
                                            onChange={handleChange}
                                            color="default"
                                            value="dynamic-class-name"
                                        />
                                    }
                                    label="Verde"
                                /> 
                                : null
                            }                                                           
                            <div>{renderRoutes(Routes)}</div>
                        </SelectorProvider>
                    </ThemeCtx.Provider>
                </ThemeProvider>
            </BrowserRouter>        
        </div>
    );
}

ReactDOM.render(<Main />, document.getElementById('root'));